import React from 'react';
import '../../../styles/global.css';

function OldFriend() {
  return (
    <div className="body-container">
      <h1>Old Friend</h1>
      <h4>Sept 2021 - Dec 2021</h4>
      <p>A student animated short about a dog's attachment to a duck plushy that reminds him of his old friend.</p>
      <div className='iframe-container'>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/702LWMz2r_o" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
      </div>

      <h3>Animation:</h3>
      <li>All squirrel shots</li>
      <li>Dog barking</li>
      <li>Plushy being thrown over the balcony</li>

      <h3>Modeling, Rigging & Shading:</h3>
      <div className='imgs-grid'>
        <img src={require('./assets/squirrel-rig.png')} />
        <img src={require('./assets/squirrel-shaded.png')} />
      </div>
    </div>
  );
};

export default OldFriend;
